/* Product page: variant selection, quantity, add to cart, kit selector, step tabs */
(function () {
  'use strict';
  var form = document.querySelector('form[data-product-form]');
  if (!form) return;
  var product = null;
  try { product = JSON.parse(document.getElementById('ProductJson').textContent); } catch (e) {}
  var idInput = form.querySelector('[name=id]');
  var priceEl = document.querySelector('[data-product-price]');
  var addBtn = form.querySelector('[data-add-to-cart]');
  var addLabel = addBtn ? addBtn.querySelector('[data-add-label]') : null;
  var stickyPrice = document.querySelector('[data-sticky-price]');

  function money(cents) {
    var fmt = (window.themeMoneyFormat || '${{amount}}');
    var amount = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount\s*\}\}/, amount).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  }

  function setVariant(variant) {
    if (!variant) return;
    idInput.value = variant.id;
    if (priceEl) priceEl.textContent = money(variant.price);
    if (stickyPrice) stickyPrice.textContent = money(variant.price);
    if (addBtn) {
      addBtn.disabled = !variant.available;
      if (addLabel) addLabel.textContent = variant.available ? (addBtn.getAttribute('data-label-add') + ' · ' + money(variant.price)) : addBtn.getAttribute('data-label-sold');
    }
    // contents panels keyed by variant id (kit selector)
    document.querySelectorAll('[data-variant-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-variant-panel') !== String(variant.id); });
    if (history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', variant.id); history.replaceState(null, '', u); }
  }

  // Variant option cards (radio-like buttons)
  document.querySelectorAll('[data-variant-option]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      document.querySelectorAll('[data-variant-option]').forEach(function (b) { b.setAttribute('aria-checked', 'false'); });
      btn.setAttribute('aria-checked', 'true');
      var v = product && product.variants.filter(function (x) { return String(x.id) === btn.getAttribute('data-variant-option'); })[0];
      setVariant(v);
    });
  });
  // Native selects fallback
  var selects = form.querySelectorAll('select[data-option]');
  selects.forEach(function (s) {
    s.addEventListener('change', function () {
      var opts = Array.prototype.map.call(selects, function (x) { return x.value; });
      var v = product && product.variants.filter(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); })[0];
      setVariant(v);
    });
  });

  // Quantity
  document.querySelectorAll('.qty').forEach(function (q) {
    var input = q.querySelector('input');
    q.querySelector('[data-qty-minus]').addEventListener('click', function () { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
    q.querySelector('[data-qty-plus]').addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 1) + 1; });
  });

  // Add-on bundle (e.g. filters) — adds a second line item
  var addon = document.querySelector('[data-addon-toggle]');
  if (addon) addon.addEventListener('click', function () {
    var on = addon.getAttribute('aria-pressed') !== 'true';
    addon.setAttribute('aria-pressed', on ? 'true' : 'false');
    addon.querySelector('[data-addon-off]').hidden = on;
    addon.querySelector('[data-addon-on]').hidden = !on;
  });

  // AJAX add
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var items = [{ id: idInput.value, quantity: parseInt(form.querySelector('[name=quantity]') ? form.querySelector('[name=quantity]').value : 1, 10) || 1 }];
    if (addon && addon.getAttribute('aria-pressed') === 'true') items.push({ id: addon.getAttribute('data-addon-variant'), quantity: 1 });
    if (addBtn) addBtn.setAttribute('aria-disabled', 'true');
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () {
        window.dispatchEvent(new CustomEvent('cart:updated'));
        if (addLabel) { var o = addLabel.textContent; addLabel.textContent = addBtn.getAttribute('data-label-added'); setTimeout(function () { addLabel.textContent = o; }, 2200); }
        if (addBtn) addBtn.removeAttribute('aria-disabled');
      })
      .catch(function () { if (addBtn) addBtn.removeAttribute('aria-disabled'); form.submit(); });
  });

  // Step tabs (how it's used)
  document.querySelectorAll('[data-steps]').forEach(function (wrap) {
    var btns = wrap.querySelectorAll('.step-tab'); var imgs = wrap.querySelectorAll('[data-step-image]');
    function go(i) { btns.forEach(function (b) { b.setAttribute('aria-selected', b.getAttribute('data-step') === i ? 'true' : 'false'); }); imgs.forEach(function (im) { im.hidden = im.getAttribute('data-step-image') !== i; }); }
    btns.forEach(function (b) { b.addEventListener('click', function () { go(b.getAttribute('data-step')); }); });
    if (btns.length) go(btns[0].getAttribute('data-step'));
  });

  // Initial state
  if (product) {
    var initial = product.variants.filter(function (v) { return String(v.id) === idInput.value; })[0] || product.variants[0];
    setVariant(initial);
  }
})();

// YouTube click-to-load (privacy-enhanced)
document.querySelectorAll('[data-yt]').forEach(function (b) {
  b.addEventListener('click', function () {
    var id = b.getAttribute('data-yt'); var f = document.createElement('iframe');
    f.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0&modestbranding=1'; f.allow = 'autoplay; encrypted-media; picture-in-picture'; f.allowFullscreen = true; f.title = 'Product video'; f.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
    var wrap = document.createElement('div'); wrap.className = 'product__video-frame'; wrap.appendChild(f); b.replaceWith(wrap);
  });
});
// Complete the kit: add both to cart
document.querySelectorAll('[data-bundle-add]').forEach(function (btn) {
  btn.addEventListener('click', function () {
    var items = btn.getAttribute('data-variants').split(',').map(function (id) { return { id: id.trim(), quantity: 1 }; });
    var label = btn.textContent; btn.setAttribute('aria-disabled', 'true');
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () { window.dispatchEvent(new CustomEvent('cart:updated')); btn.textContent = btn.getAttribute('data-label-added') || 'Added'; setTimeout(function () { btn.textContent = label; btn.removeAttribute('aria-disabled'); }, 2200); var open = document.querySelector('[data-cart-open]'); if (open && window.innerWidth >= 750) open.click(); })
      .catch(function () { btn.removeAttribute('aria-disabled'); window.location.href = '/cart'; });
  });
});
